const LOGIN_FORM_SEND = 'LOGIN_FORM_SEND';
const LOGIN_SUCCESSED = 'LOGIN_SUCCESSED';
const LOGIN_SET_API_ERROR = 'LOGIN_SET_API_ERROR';
const LOGIN_FAILED = 'LOGIN_FAILED';
const LOGIN_FACEBOOK_FORM_SEND = 'LOGIN_FACEBOOK_FORM_SEND';
const LOGIN_CONFIRMED_USER = 'LOGIN_CONFIRMED_USER';

const loginFormSend = (userName, password) => ({
  type: LOGIN_FORM_SEND,
  payload: {
    userName,
    password
  }
});

const loginSetApiError = (payload) => ({
  type: LOGIN_SET_API_ERROR,
  payload
});

const loginConfirmedUser = () => ({
  type: LOGIN_CONFIRMED_USER
});

const loginFacebookSendForm = () => ({ type: LOGIN_FACEBOOK_FORM_SEND });

const loginSuccessed = () => ({ type: LOGIN_SUCCESSED });

const loginFailed = () => ({ type: LOGIN_FAILED });

export {
  LOGIN_FACEBOOK_FORM_SEND,
  LOGIN_SET_API_ERROR,
  LOGIN_SUCCESSED,
  LOGIN_FAILED,
  LOGIN_FORM_SEND,
  LOGIN_CONFIRMED_USER,
  loginConfirmedUser,
  loginFacebookSendForm,
  loginSetApiError,
  loginFormSend,
  loginFailed,
  loginSuccessed
};
